export default __webpack_public_path__ + "static/media/civil.a6c5880b.png";